// extracted by mini-css-extract-plugin
module.exports = {"isShared":"menu-model_isShared__1Knad"};